import { CdkHeaderCell, CdkHeaderCellDef } from '@angular/cdk/table';
import { Directive, HostBinding, Input } from '@angular/core';

/**
 * Header cell definition for the table.
 * Captures the template of a column's header cell and as well as cell-specific properties.
 */
@Directive({
  selector: '[nHeaderCellDef]',
  providers: [{ provide: CdkHeaderCellDef, useExisting: NHeaderCellDefDirective }],
})
export class NHeaderCellDefDirective extends CdkHeaderCellDef {}

/** Header cell template container that adds the right classes and role. */
@Directive({
  selector: 'n-header-cell, th[n-header-cell]',
})
export class NHeaderCellDirective extends CdkHeaderCell {
  @HostBinding('attr.class') cssClasses: string;
  @HostBinding('attr.role') role = 'columnheader';
  @Input() set class(classNames: string) {
    this.cssClasses = `n-header-cell ${classNames}`;
  }
}
